(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[311],{

/***/ 88707:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vorusafn/[id]",
      function () {
        return __webpack_require__(43195);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; },
  "setUndefinedNull": function() { return /* binding */ setUndefinedNull; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/api/saleor/generated/index.tsx
var generated = __webpack_require__(49554);
// EXTERNAL MODULE: ./src/components/layout/PageContainer.tsx + 4 modules
var PageContainer = __webpack_require__(78823);
// EXTERNAL MODULE: ./src/api/datocms/utils.ts + 4 modules
var utils = __webpack_require__(39802);
// EXTERNAL MODULE: ./src/api/datocms/queries/index.ts + 2 modules
var queries = __webpack_require__(6487);
// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var products = __webpack_require__(18254);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
;// CONCATENATED MODULE: ./src/components/collection/CollectionPage.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  place-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  over-flow: visible;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    top: 0;\n    border-top: border-top: 1px solid ",
        ";\n    border-bottom: none !important;\n    border-left: none !important;\n    border-right: none;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\nposition: relative;\ntop:0;\nright:0;\nwidth: 220px;\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\nalign-items: center;\nbackground-color: ",
        ";\nborder-radius: 5px;\nborder: 1.5px solid ",
        ";\n  .sort-button {\n    background-color: transparent;\n    border: none !important;\n    outline: none !important;\n    width: 100%;\n    height: 40px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    span {\n      font-size: 16px;\n      flex-grow: 1;\n      display: flex;\n      justify-content: flex-start;\n    }\n  }\n}\n.options {\n  width: 100%;\n  position: absolute;\n  top: 40px;\n  z-index: 10;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  ",
        "\n  li {\n    padding: 5px;\n    button {\n    width: 100%;\n    text-align: left;\n    background-color: transparent;\n    border: none !important;\n    font-size: 16px;\n    &:hover {\n      color: ",
        ";\n    }\n    .selected {\n      button {\n        color: ",
        ";\n      }\n    }\n    }\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\nalign-self: flex-end;\nmargin-bottom: 10px;\n.arrow {\n  border: solid black;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n.down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var GetItem = function(param) {
    var product = param.product;
    var element = (0,react.useMemo)(function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(products/* ProductCard */.Il, {
            slug: product.node.slug,
            render: function(children) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Col, {
                    col: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    children: children
                }, (ref = product.node) === null || ref === void 0 ? void 0 : ref.id);
            }
        }, product.node.id);
    }, [
        product
    ]);
    if (!element || !product.node.id || !product.node.variants || product.node.variants.length === 0) {
        return null;
    }
    return element;
};
var LoaderContainer = styled_components_browser_esm["default"].div(_templateObject());
var CenterContainer = styled_components_browser_esm["default"].div(_templateObject1());
var SortDropdown = styled_components_browser_esm["default"].div(_templateObject3(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), dist.media.xl(_templateObject2(), (0,es/* palette */.DG)("black")), themes/* theme.palette.error */.r.palette.error, themes/* theme.palette.error */.r.palette.error);
function CollectionPage(param) {
    var collection = param.collection, checked = param.checked, onClick = param.onClick, sortClass = param.sortClass, handleChange = param.handleChange, showLoading = param.showLoading;
    var ref2, ref1;
    var SortContainer = function() {
        var ref = (0,react.useState)(false), showDropdown = ref[0], setShowDropdown = ref[1];
        var options = {
            new: "N\xfdjast",
            price_asc: "L\xe6gsta ver\xf0",
            alph_asc: "Nafn"
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortDropdown, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "sort-button",
                    onClick: function() {
                        return setShowDropdown(!showDropdown);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: sortClass ? "Ra\xf0a eftir: ".concat(options[sortClass]) : "Ra\xf0a eftir: Nafn"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: showDropdown ? "arrow up" : "arrow down"
                        })
                    ]
                }),
                showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "options",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    // onClick={() => handleChange({ field: "DATE", direction: "DESC" }, "new")}
                                    onClick: function() {
                                        return handleChange("new");
                                    },
                                    className: sortClass === "new" ? "selected" : "",
                                    children: options.new
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return handleChange("price_asc");
                                    },
                                    className: sortClass === "price_asc" ? "selected" : "",
                                    children: options.price_asc
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return handleChange("alph_asc");
                                    },
                                    className: sortClass === "alph_asc" ? "selected" : "",
                                    children: options.alph_asc
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var _slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* SpacingWrapper */.$3, {
        spacing: 32,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H1, {
                withGutter: true,
                children: (collection === null || collection === void 0 ? void 0 : collection.name) || "Vefverslun"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* Checkbox */.XZ, {
                        label: "S\xeda vistv\xe6nar v\xf6rur",
                        checked: checked,
                        onClick: onClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortContainer, {})
                ]
            }),
            showLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {
                    loaderKey: collection === null || collection === void 0 ? void 0 : collection.name,
                    size: 48
                })
            }),
            !showLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                children: collection === null || collection === void 0 ? void 0 : (ref2 = collection.products) === null || ref2 === void 0 ? void 0 : (ref1 = ref2.edges) === null || ref1 === void 0 ? void 0 : ref1.map(function(product, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GetItem, {
                        product: product
                    }, (_slug = product.node.slug) !== null && _slug !== void 0 ? _slug : index);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
// EXTERNAL MODULE: ./src/components/genericPage/index.ts + 1 modules
var genericPage = __webpack_require__(39884);
// EXTERNAL MODULE: ./src/components/content/DatocmsContent.tsx + 30 modules
var DatocmsContent = __webpack_require__(32437);
// EXTERNAL MODULE: ./src/utils/isSSR.ts
var isSSR = __webpack_require__(28095);
// EXTERNAL MODULE: ./src/utils/gqlQuery/gqlQuery.ts
var gqlQuery = __webpack_require__(66754);
// EXTERNAL MODULE: ./src/utils/products.ts
var utils_products = __webpack_require__(5979);
;// CONCATENATED MODULE: ./src/pages/vorusafn/[id].tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _id_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _id_templateObject() {
    var data = _id_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  place-items: center;\n"
    ]);
    _id_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// import { Page_landingPage, LandingPage } from 'src/api/datocms/types/LandingPage'














var _id_LoaderContainer = styled_components_browser_esm["default"].div(_id_templateObject());
var __N_SSP = true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var setUndefinedNull = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj) {
    if (obj) {
        Object.keys(obj).forEach(function(key) {
            if (obj[key] && typeof obj[key] === "object") {
                setUndefinedNull(obj[key]);
            } else if (typeof obj[key] === "undefined") {
                obj[key] = null // eslint-disable-line no-param-reassign
                ;
            }
        });
    }
};
var Vorusafn = function(param1) {
    var pageSubscription = param1.pageSubscription;
    var ref16, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,next_router.useRouter)();
    var id = Array.isArray(router.query.id) ? router.query.id[0] : router.query.id;
    var ref8 = (0,react.useMemo)(function() {
        return {
            current: 0
        };
    }, []);
    if (true) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ref8 = (0,react.useRef)(Number(sessionStorage.getItem("scrollPosition_".concat(id))));
    }
    var ref9 = (0,react.useState)(function() {
        return router.query.sort || "alph_asc";
    }), sortOpt = ref9[0], setSortOpt = ref9[1];
    var ref10 = (0,react.useState)(function() {
        var // eslint-disable-next-line no-unneeded-ternary
        ref;
        return (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.ecofriendly) ? true : false;
    }), envFilter = ref10[0], setEnvFilter = ref10[1];
    var ref11 = (0,react.useState)(false), showLoader = ref11[0], setShowLoader = ref11[1];
    var ref12 = (0,react.useState)(false), showMoreLoader = ref12[0], setShowMoreLoader = ref12[1];
    (0,react.useEffect)(function() {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        var handleScroll = function() {
            sessionStorage.setItem("scrollPosition_".concat(id), "".concat(window.scrollY));
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        id
    ]);
    var ref13 = (0,react.useState)(null), landingPage = ref13[0], setLandingPage = ref13[1];
    (0,react.useEffect)(function() {
        var ref20, ref17;
        if ((pageSubscription === null || pageSubscription === void 0 ? void 0 : (ref20 = pageSubscription.initialData) === null || ref20 === void 0 ? void 0 : ref20.collectionLandingPage) && (pageSubscription === null || pageSubscription === void 0 ? void 0 : (ref17 = pageSubscription.initialData) === null || ref17 === void 0 ? void 0 : ref17.collectionLandingPage.collectionId) === id) {
            var ref18;
            setLandingPage(pageSubscription === null || pageSubscription === void 0 ? void 0 : (ref18 = pageSubscription.initialData) === null || ref18 === void 0 ? void 0 : ref18.collectionLandingPage);
        } else {
            (0,utils/* makeSubscriptionProps */.qQ)(false, queries/* collectionLandingPageQuery */.t3, {
                collectionId: id
            }, true).catch(function(err) {
                console.log({
                    err: err
                });
            }).then(function(data) {
                var ref, ref19;
                setLandingPage((ref = data) === null || ref === void 0 ? void 0 : (ref19 = ref.initialData) === null || ref19 === void 0 ? void 0 : ref19.collectionLandingPage);
                return Promise.resolve();
            }).then(function() {
                return window.scrollTo(0, +ref8.current);
            });
        }
    }, [
        pageSubscription === null || pageSubscription === void 0 ? void 0 : (ref16 = pageSubscription.initialData) === null || ref16 === void 0 ? void 0 : ref16.collectionLandingPage,
        id,
        landingPage,
        ref8, 
    ]);
    var deleteUrlParams = function(key) {
        var updateUrl = new URL(window.location.href);
        var params = new URLSearchParams(updateUrl.search);
        params.delete(key);
        router.push("".concat(window.location.pathname, "?").concat(params.toString()), undefined, {
            shallow: true
        });
    };
    (0,react.useEffect)(function() {
        if (!router.query.sort) {
            setSortOpt("alph_asc");
            window.scrollTo(0, ref8.current);
        } else if (router.query.sort) {
            setSortOpt(router.query.sort);
            window.scrollTo(0, ref8.current);
        }
    }, [
        router === null || router === void 0 ? void 0 : router.query,
        ref8
    ]);
    var AddUrlParams = function(param) {
        var key = param.key, value = param.value;
        // eslint-disable-next-line no-restricted-globals
        var updateUrl = new URL(window.location.href);
        var params = new URLSearchParams(updateUrl.search);
        params.set(key, value !== null && value !== void 0 ? value : "");
        router.push("".concat(window.location.pathname, "?").concat(params.toString()), undefined, {
            shallow: true
        });
    };
    var ref14 = (0,gqlQuery/* useQueryWithCache */.SR)(generated/* GetAttributesDocument */.o54, {
        fetchPolicy: isSSR/* isSSR */.y ? "cache-only" : "cache-first",
        variables: {
            slug: "certifications-eco"
        }
    }), attributeData = ref14.data;
    var envAttrValues = (0,react.useMemo)(function() {
        var ref, ref21;
        var attrArr = [];
        attributeData === null || attributeData === void 0 ? void 0 : (ref = attributeData.attribute) === null || ref === void 0 ? void 0 : (ref21 = ref.choices) === null || ref21 === void 0 ? void 0 : ref21.edges.forEach(function(choice) {
            return choice.node.slug ? attrArr.push(choice.node.slug) : null;
        });
        return attrArr;
    }, [
        attributeData
    ]);
    var ecoFilter;
    if (router.query.ecofriendly) {
        ecoFilter = {
            attributes: [
                {
                    slug: "certifications-eco",
                    values: _toConsumableArray(envAttrValues)
                }
            ]
        };
    } else {
        ecoFilter = {
            attributes: [
                {
                    slug: "certifications-eco"
                }
            ]
        };
    }
    var ref15 = (0,generated/* useCollectionQuery */.aG9)({
        query: generated/* CollectionDocument */.Alj,
        context: {
            nonAuthorized: true
        },
        skip: id == null,
        variables: {
            id: id !== null && id !== void 0 ? id : "",
            first: 24,
            after: null
        }
    }), data1 = ref15.data, loading = ref15.loading, fetchMore = ref15.fetchMore, refetch = ref15.refetch;
    (0,react.useEffect)(function() {
        if (envFilter) {
            // window.scrollTo(0, 0)
            AddUrlParams({
                key: "ecofriendly",
                value: "true"
            });
            setShowLoader(true);
            refetch({
                sortBy: utils_products/* sortingArgsMap */.S1[sortOpt][0],
                filter: {
                    attributes: [
                        {
                            slug: "certifications-eco",
                            values: _toConsumableArray(envAttrValues)
                        }, 
                    ]
                }
            }).then(function() {
                return setShowLoader(false);
            }).then(function() {
                return window.scrollTo(0, ref8.current);
            });
        } else {
            deleteUrlParams("ecofriendly");
            setShowLoader(true);
            refetch({
                sortBy: utils_products/* sortingArgsMap */.S1[sortOpt][0],
                filter: {
                    attributes: [
                        {
                            slug: "certifications-eco"
                        }
                    ]
                }
            }).then(function() {
                return setShowLoader(false);
            }).then(function() {
                return window.scrollTo(0, ref8.current);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        envFilter
    ]);
    var fetchMoreProducts = function() {
        var ref, ref22, ref23, ref24, ref25, ref26;
        if (data1 === null || data1 === void 0 ? void 0 : (ref = data1.collection) === null || ref === void 0 ? void 0 : (ref22 = ref.products) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.pageInfo) === null || ref23 === void 0 ? void 0 : ref23.hasNextPage) setShowMoreLoader(true);
        fetchMore({
            query: generated/* CollectionDocument */.Alj,
            variables: {
                id: id,
                first: 24,
                after: data1 === null || data1 === void 0 ? void 0 : (ref24 = data1.collection) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.products) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.pageInfo) === null || ref26 === void 0 ? void 0 : ref26.endCursor,
                sortBy: utils_products/* sortingArgsMap */.S1[sortOpt][0],
                filter: ecoFilter
            }
        }).then(function() {
            return setShowMoreLoader(false);
        });
    };
    if (!isSSR/* isSSR */.y && loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericPage/* PageLoading */.S, {});
    }
    if ((!data1 || !data1.collection) && !loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericPage/* PageContent */.J, {
            label: "V\xf6rusafn finnst ekki",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H2, {
                    children: "V\xf6rusafn finnst ekki"
                })
            })
        });
    }
    var handleChange = function(filter) {
        setShowLoader(true);
        refetch({
            sortBy: utils_products/* sortingArgsMap */.S1[filter][0]
        }).then(function() {
            return setShowLoader(false);
        });
        setSortOpt(filter);
        AddUrlParams({
            key: "sort",
            value: filter
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
        title: "".concat(data1 === null || data1 === void 0 ? void 0 : (ref1 = data1.collection) === null || ref1 === void 0 ? void 0 : ref1.name, " | Rekstrarv\xf6rur"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* Breadcrumbs */.Oo, {
                    breadcrumbs: [
                        {
                            title: "Fors\xed\xf0a",
                            href: paths/* paths.home */.H.home
                        },
                        {
                            title: data1 === null || data1 === void 0 ? void 0 : (ref2 = data1.collection) === null || ref2 === void 0 ? void 0 : ref2.name,
                            href: router.asPath
                        }, 
                    ]
                }),
                (landingPage === null || landingPage === void 0 ? void 0 : landingPage.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatocmsContent/* DatocmsContent */.P, {
                    content: landingPage.content
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionPage, {
                    collection: data1 === null || data1 === void 0 ? void 0 : data1.collection,
                    checked: envFilter,
                    onClick: function() {
                        return setEnvFilter(!envFilter);
                    },
                    sortClass: sortOpt,
                    handleChange: handleChange,
                    showLoading: showLoader
                }),
                showMoreLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(_id_LoaderContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {
                        loaderKey: id,
                        size: 24
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Vorusafn.PaginInationIndicator, {
                    currentCount: data1 === null || data1 === void 0 ? void 0 : (ref3 = data1.collection) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.products) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.edges) === null || ref5 === void 0 ? void 0 : ref5.length,
                    totalCount: data1 === null || data1 === void 0 ? void 0 : (ref6 = data1.collection) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.products) === null || ref7 === void 0 ? void 0 : ref7.totalCount,
                    onClickMore: fetchMoreProducts,
                    loading: loading
                })
            ]
        })
    });
};
Vorusafn.PaginInationIndicator = function(param) {
    var loading = param.loading, currentCount = param.currentCount, totalCount = param.totalCount, onClickMore = param.onClickMore;
    if (loading || !currentCount || !totalCount) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* PaginationIndicator */.Ze, {
        currentCount: currentCount,
        totalCount: totalCount,
        onClickMore: onClickMore
    });
};
/* harmony default export */ var _id_ = (Vorusafn);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [370,466,104,12,127,221,774,888,179], function() { return __webpack_exec__(88707); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);